import request from '@/services/interceptor.js'

export const get_notifiche = () => {
    return request({ url: '/notifiche', method: 'get', loadingBar: true })
}

export const get_conteggio_non_lette = () => {
    return request({ url: '/notifiche/non-lette/conteggio', method: 'get' })
}

export const segna_notifica_letta = (id) => {
    return request({ url: `/notifiche/${id}/letta`, method: 'post' })
}

export const segna_tutte_lette = () => {
    return request({ url: '/notifiche/segna-tutte-lette', method: 'post', loadingBar: true })
}
